import { getEventAssessmentQuestions } from 'data/mock-data';

const mock = () => ({
  data: {
    assessmentData: getEventAssessmentQuestions,
  },
});

export default mock;
